import React, { useEffect } from "react";
// import ReactGA from "react-ga";
import ReactGA from "react-ga4";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import GoogleAnalyticsListener from "./components/util/GoogleAnalyticsListener";


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import "bootstrap/dist/js/bootstrap.bundle.min";
import './App.css';

import WhatsappLogo from "./assets/icons/whatsapp-icon.svg"

import NavigationBar from "./components/util/nav/navBar";
import Footer from "./components/util/footer/footer";



// import BlogPost from "./components/commonPageComponents/blogPost/blogPost";

// import PrivacyPolicy  from "./components/util/privacyPolicy/privacyPolicy";



import CookiePolicyModal from "./components/util/cookies/cookiePolicyModal";
import ScrollToTop from "./components/util/scrolltoTop";
import EventPage from "./components/pages/lifeAtMindOx/events/eventDetails";



// const Tracking_ID = "G-WPD3L9D3E5";
// ReactGA.initialize(Tracking_ID);

const TRACKING_ID = "G-WPD3L9D3E5";
ReactGA.initialize(TRACKING_ID, { debug_mode: true });

const PrivacyPolicy = React.lazy(() => import("./components/util/privacyPolicy/privacyPolicy"))
const LeadershipPage = React.lazy(() => import("./components/pages/lifeAtMindOx/leadership"))
const ProcessEquipment = React.lazy(() => import("./components/pages/products/processEquipment"));

const ContactSales = React.lazy(() => import("./components/pages/contact/contactSales"));
const ContactUs = React.lazy(() => import("./components/pages/contact/contactUs"));
const PostWarrantyServices = React.lazy(() => import("./components/pages/services/postWarrantyServices/postWarrantyServices"));
const Internship = React.lazy(() => import("./components/pages/lifeAtMindOx/careers/internships/internship"));

const AvailableSoon = React.lazy(() => import("./components/pages/Error/availableSoon"));
const PostPage = React.lazy(() => import("./components/pages/home/postPage/postPage"));

const SalesContactForm = React.lazy(() => import("./components/forms/sale-form"));
const Loadlock = React.lazy(() => import("./components/pages/products/platformSolutions/loadLock"));
const VacuumTransferModule = React.lazy(() => import("./components/pages/products/platformSolutions/vTM"));
const AtmosphericTransferModule = React.lazy(() => import("./components/pages/products/platformSolutions/aTM"));
const AutomationSolutions = React.lazy(() => import("./components/pages/products/AutomationSolutions"));
const EndEffector = React.lazy(() => import("./components/pages/products/platformSolutions/endEffector"));
const EquipmentSoftwareSolutions = React.lazy(() => import("./components/pages/services/equipmentSoftwareSolutions"));
const LoadPort = React.lazy(() => import('./components/pages/products/platformSolutions/loadPort'));
const ResourcesCenter = React.lazy(() => import("./components/pages/services/resourceCenter"));
const EFEMProductControlSys = React.lazy(() => import("./components/pages/services/efemProdContSys"));
const ManufacturingSubContract = React.lazy(() => import("./components/pages/services/manufacturingSubContract"));
const PressReleases = React.lazy(() => import("./components/pages/resources/pressReleases"));
const ProductLaunches = React.lazy(() => import("./components/pages/resources/productLaunches"));
const KnowledgeHub = React.lazy(() => import("./components/pages/resources/knowledgeHub"));
const EcoMask = React.lazy(() => import("./components/pages/products/AdvanceMaterials"));

const JobDetails = React.lazy(() => import("./components/pages/lifeAtMindOx/careers/jobDetails/jobDetail"));

const PressReleaseDetail = React.lazy(() => import("./components/pages/resources/pressReleases/pressReleaseDetails"));
const ProductLaunchesDetail = React.lazy(() => import("./components/pages/resources/productLaunches/productLaunchesDetails"));
//General Pages
const Home = React.lazy(() => import('./components/pages/home'));
const AboutUs = React.lazy(() => import("./components/pages/lifeAtMindOx/aboutUs"));
const Careers = React.lazy(() => import("./components/pages/lifeAtMindOx/careers"));
const Events = React.lazy(()=> import("./components/pages/lifeAtMindOx/events"));
const Contact = React.lazy(() => import("./components/pages/contact/index"));
const CoatingCuringNCleaningTool = React.lazy(() => import('./components/pages/products/processEquipment/coatingCuringNCleaningTool'));
const CopperPassivationCoatingTool = React.lazy(() => import('./components/pages/products/processEquipment/copperPassivationCoatingTool'));


const PlatformSolutions = React.lazy(() => import('./components/pages/products/platformSolutions'));
const EFEM = React.lazy(() => import('./components/pages/products/EFEM'));
const Error404 = React.lazy(() => import('./components/pages/Error/error404'))

function App() {
  useEffect(() => {
    // Clear all cookies
    document.cookie.split(';').forEach((c) => {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });

    // ReactGA.pageview(window.location.pathname);
  }, []);
  return (
    <>
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <GoogleAnalyticsListener />
          <NavigationBar />

          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/platform-solutions" element={<PlatformSolutions />} > */}
            <Route path="/platform-solutions" element={<PlatformSolutions />} />
            <Route path="/platform-solutions/e-f-e-m" element={<EFEM />} />
            <Route path="/platform-solutions/end-effector" element={<EndEffector />} />
            <Route path="/platform-solutions/load-port" element={<LoadPort />} />
            <Route path="/platform-solutions/loadlock" element={<Loadlock />} />
            <Route path="/platform-solutions/vacuum-transfer-module" element={<VacuumTransferModule />} />
            <Route path="/platform-solutions/atmospheric-transfer-module" element={<AtmosphericTransferModule />} />

            <Route path="/process-equipment" element={<ProcessEquipment />} />
            <Route path="/process-equipment/coating,-curing-&-cleaning-tool" element={<CoatingCuringNCleaningTool />} />
            <Route path="/process-equipment/copper-passivation-coating-tool" element={<CopperPassivationCoatingTool />} />
            <Route path="/advance-materials/eco-mask" element={<EcoMask />} />

            <Route path="/automation-solutions" element={<AutomationSolutions />} />
            <Route path="/customized-software-solution" element={<EquipmentSoftwareSolutions />} />
            <Route path="/manufacturing-sub-contract" element={<ManufacturingSubContract />} />
            <Route path="/e-f-e-m-product-control-system" element={<EFEMProductControlSys />} />
            <Route path="/engineering-resources" element={<ResourcesCenter />} />
            <Route path="/post-warranty-services" element={<PostWarrantyServices />} />

            <Route path="/press-releases" element={<PressReleases />} />
            <Route path="/press-releases/:slug" element={<PressReleaseDetail />} />
            <Route path="/product-launches" element={<ProductLaunches />} />
            <Route path="/product-launches/:slug" element={<ProductLaunchesDetail />} />
            <Route path="/knowledge-hub" element={<KnowledgeHub />} />

            <Route path="/life-at-mindox/about-us" element={<AboutUs />} />
            <Route path="/life-at-mindox/leadership-team" element={<LeadershipPage />} />
            <Route path="/life-at-mindox/careers" element={<Careers />} />
            <Route path="/life-at-mindox/events" element={<Events/>}/>
            <Route path="/life-at-mindox/events/:id/:slug" element={<EventPage/>}/>
            <Route path="/life-at-mindox/careers/internships" element={<Internship />} />
            <Route path="/life-at-mindox/careers/vacancy/:id" element={<JobDetails />} />
            <Route path="/old-contact-us" element={<Contact />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/contact-sales" element={<ContactSales />} />
            <Route path="/sales-contact" element={<SalesContactForm />} />
            <Route path="/available-soon" element={<AvailableSoon />} />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* <Route path="/press-releases/accelerating-semiconductor-innovation" element={<PostPage />} /> */}
            <Route path="/*" element={<Error404 />} />

            
            {/* Redirects within the website */}

            {/* About Us page redirect */}
            <Route path="/about-us" element={<Navigate to={"/life-at-mindox/about-us"} />} />
            
            {/* Advance Materials page redirect */}
            <Route path="/advance-materials" element={<Navigate to={"/advance-materials/eco-mask"} />} />

            {/* Career page redirects */}
            <Route path="/company/careers" element={<Navigate to={"/life-at-mindox/careers"} />} />
            <Route path="/life-at-mindox" element={<Navigate to={"/about-us"} />} />
            <Route path="/life-at-mindox/careers/vacancy" element={<Navigate to={"/life-at-mindox/careers"} />} />
            
            {/* Product page redirects */}
            <Route path="/product/efem" element={<Navigate to={"/platform-solutions/e-f-e-m"} />} />
            <Route path="/product/accessories#LPdiv" element={<Navigate to={"/platform-solutions/load-port"} />} />
            <Route path="/equipment" element={<Navigate to={"/process-equipment"} />} />
            <Route path="/product/accessories#EEdiv" element={<Navigate to={"/platform-solutions/end-effector"} />} />

            
          </Routes>
          {/* <a aria-label="WhatsApp" className="whatsapp" href="https://web.whatsapp.com/send?phone=+6581128732&text&app_absent=0" target="blank"  >
            <i className="bi bi-whatsapp my-float"></i>
          </a> */}
          {/* new icon */}
          {/* <a aria-label="WhatsApp" className="whatsapp" href="https://web.whatsapp.com/send?phone=+6581128732&text&app_absent=0">
            <img src={WhatsappLogo} alt="Whatsapp Icon" className="whatsapp-logo" target="blank" />
          </a> */}
          <CookiePolicyModal />
          <Footer />

        </Router>
      </HelmetProvider>
    </>
  );
}

export default App;
